module.exports = {
    HEADER_FOCUS_DELAY: 300
};



// WEBPACK FOOTER //
// ./app/scripts/constants/accessibility.js